const AI_SOURCES: Record<string, string> = {
  'chatgpt.com': 'chatgpt',
  'perplexity.ai': 'perplexity',
  'gemini.google.com': 'gemini',
  'copilot.microsoft.com': 'copilot',
}

function normalizedAiSource(value: string | null): string | undefined {
  if (!value) return undefined
  const source = value.trim().toLowerCase().replace(/^https?:\/\//, '').split('/')[0]!
  for (const [host, label] of Object.entries(AI_SOURCES)) {
    if (source === host || source.endsWith(`.${host}`)) return label
  }
  return undefined
}

export function aiAttribution(locationHref: string, referrer: string): string | undefined {
  try {
    const location = new URL(locationHref)
    const utmSource = normalizedAiSource(location.searchParams.get('utm_source'))
    if (utmSource) return utmSource
  } catch {
    // Ignore malformed locations and fall through to the referrer.
  }
  try {
    return normalizedAiSource(new URL(referrer).hostname)
  } catch {
    return undefined
  }
}

/**
 * Analytics is intentionally restricted to public discovery pages. Query
 * strings and fragments are never returned, so reset/preview/payment tokens
 * and account identifiers cannot be sent to GA.
 */
export function safePublicPageLocation(locationHref: string): string | undefined {
  try {
    const url = new URL(locationHref)
    const path = url.pathname.replace(/\/{2,}/g, '/')
    const withoutLocale = path.replace(/^\/(?:en|fr|pt|zh)(?=\/|$)/, '') || '/'
    const publicRoute = withoutLocale === '/'
      || /^\/shop\/?$/.test(withoutLocale)
      || /^\/producto\/[^/]+\/?$/.test(withoutLocale)
      || /^\/blog(?:\/(?:category|tag)\/[^/]+|\/[^/]+)?\/?$/.test(withoutLocale)
      || /^\/p\/[^/]+\/?$/.test(withoutLocale)
    return publicRoute ? `${url.origin}${path}` : undefined
  } catch {
    return undefined
  }
}

export function safePageReferrer(referrer: string, currentOrigin: string): string | undefined {
  if (!referrer) return undefined
  try {
    const url = new URL(referrer)
    if (url.origin !== currentOrigin) return url.origin
    return safePublicPageLocation(url.href)
  } catch {
    return undefined
  }
}

export function syntheticPurchaseLocation(origin: string): string {
  return `${origin}/purchase-confirmation`
}
